module.exports = __webpack_public_path__ + "img/madeInMarseille-header.3d4310b8.jpg";